import { render, staticRenderFns } from "./NotificationCooldown.vue?vue&type=template&id=3f62c664&"
import script from "./NotificationCooldown.vue?vue&type=script&lang=ts&"
export * from "./NotificationCooldown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports